export enum PAGES {
  signIn = 'sign-in',
  signUp = 'sign-up'
}
